import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { currentcartdetail } from '../../models/dashboard/cart/mywallet.currentcart.Modal';
import { PickupType, SendMoneyDetail, SendMoneyProgramDetail, SendMoneySteps } from '../../models/sendmoney/sendmoney';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../sharedcomponents/commonservice/countrylist.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { countrylist } from '../../sharedcomponents/_common/countrylist/countrylist.component';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { CartServiceService } from '../../_services/dashboardservice/cart/cart-service.service';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { AuthService } from '../../_services/userservice/auth.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { userGioLocationService } from '../../_services/UserService/user.giolocation.service';
import { UserStateService } from '../../_services/userservice/userstateservice';

@Component({
  selector: 'app-pickup-type',
  templateUrl: './pickup-type.component.html',
  styleUrls: ['./pickup-type.component.css'],
  providers: [AuthService, AlertService, CountryService, Modal]
})
export class PickupTypeComponent implements OnInit, OnDestroy {
  sendMoneyDetail: SendMoneyDetail;
  pickupTypeData: any = {};
  countrycollection: any;
  pickupType: any;
  custPrefCountry = '';
  appSettings: any;
  PageFlow: any = {};
  srcCountryImage: any;
  private subModalpopup: any;
  private subSendMoneyProgram: any;
  constructor(
    private router: Router,
    private authService: AuthService,
    private alertService: AlertService,
    private countryserv: CountryService,
    private userCommon: usercommonattribute,
    private sendMoneyService: SendMoneyService,
    private cartservice: CartServiceService,
    private userGioLocationSer: userGioLocationService,
    private modal: Modal,
    private translate: TranslateService,
    private utilserv: utilityService,
    private userStateService: UserStateService,
    public domSanitizer: DomSanitizer
  ) {
    // this.sendMoneyService.getPageFlow().subscribe(data => {
    //   this.PageFlow = data;
    // });
    this.PageFlow.Value = sessionStorage.PageFlow;
    this.countrycollection = this.countryserv.getCountryListFromLocaleEx();
    this.sendMoneyDetail = new SendMoneyDetail();
    if (this.PageFlow.Value == 'repeatorder') {
      this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
        this.sendMoneyDetail = data;
      });
    }
    this.appSettings = AppSettings;
    this.sendMoneyService.getcurrentcartDetailData().subscribe(data => {
      this.sendMoneyDetail.currentCartDetail = data;
    });
    // this.getcartDetails();
    this.userGioLocationSer.getserGioLocation().subscribe(data => {
      this.sendMoneyDetail.userGioLocation = data;
    });
    this.subSendMoneyProgram = this.sendMoneyService.getSendMoneyProgramDetailData().subscribe(data => {
      this.sendMoneyDetail.sendMoneyProgramDetail = data;
      this.sendMoneyDetail.agentDetails.ProgramId = data.ProgramId;
    });

    // this.sendMoneyDetail.userDetails = this.authService.getUserDetailsFromLocale();

    this.userStateService.getcurrentUserDetailData().subscribe(data => {
      this.sendMoneyDetail.userDetails = data;
    });

    if (this.PageFlow.Value == 'repeatorder') {
      this.pickupTypeData = this.sendMoneyDetail.pickupTypeDetails;
    } else if (this.sendMoneyDetail.userDetails.countryPreference != undefined && this.sendMoneyDetail.userDetails.countryPreference != '') {
      this.pickupTypeData.countryPreference = this.sendMoneyDetail.userDetails.countryPreference;
      this.pickupTypeData.countryName = this.getCountryName(this.pickupTypeData.countryPreference);
    } else {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.cntrInit();
  }

  loadCountryImageFile() {
    if(this.pickupTypeData.countryPreference==undefined || this.pickupTypeData.countryPreference ==null){
      return;
    }
    this.utilserv.getCountryImage(this.pickupTypeData.countryPreference).subscribe(
      res => {
        this.srcCountryImage = res;
      },
      error => {
        console.log(error);
      }
    );
    // this.utilityServ.getCountryImage(this.userprefCountry).subscribe(res => {
    //   this.destCountryImage = res;
    // });
  }
  getcartDetails() {
    let curcarddetailresponsemodel = new currentcartdetail();
    this.utilserv.busy = this.cartservice.getcarttypeservice().subscribe(
      data => {
        if (data.StatusCode == 10000) {
          curcarddetailresponsemodel.CartExpiry = this.utilserv.getObjectText(data.CartExpiry);
          curcarddetailresponsemodel.CustmerPaymentMethod = this.utilserv.getObjectText(data.CustmerPaymentMethod);
          curcarddetailresponsemodel.FundingId = this.utilserv.getObjectText(data.FundingId);
          curcarddetailresponsemodel.GuaranteedCancellationPeriod = this.utilserv.getObjectText(data.GuaranteedCancellationPeriod);
          curcarddetailresponsemodel.ItemCount = this.utilserv.getObjectText(data.ItemCount);
          curcarddetailresponsemodel.StoreId = this.utilserv.getObjectText(data.StoreId);
          curcarddetailresponsemodel.StoreName = this.utilserv.getObjectText(data.StoreName);
          curcarddetailresponsemodel.SuperSend = this.utilserv.getObjectText(data.SuperSend);
          curcarddetailresponsemodel.UnReadMessageCount = this.utilserv.getObjectText(data.UnReadMessageCount);

          this.sendMoneyService.setcurrentcartDetailData(curcarddetailresponsemodel);
        }
      },
      error => {}
    );
  }
  getCountryName(contryCode) {
    let CountryNames = this.countrycollection.filter(function(country) {
      return country.CountryCode === contryCode;
    });

    if (CountryNames.length > 0) {
      return CountryNames[0].CountryNames[0].Name;
      // .filter(
      //   cn => cn.Language.toLowerCase() == sessionStorage.langCode.toLowerCase()
      // )[0].Name;
    }
  }

  ngOnInit() {
    // this.openDoNotRefreshbackPoppup();
  }

  cntrInit() {
    this.populatePickupType();
    this.loadCountryImageFile();
  }
  openCountryBox() {
    let self = this;
    let modalData: any = {};
    modalData.src = 'pickuptype';
    modalData.Title = this.translate.instant('CountryPreference_titleLogin').toString();
    modalData.Message = this.translate.instant('CountryPreference_descLogin').toString(); //'Please select your Country of preference from the list below:';
    return this.modal.open(countrylist, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next.CountryCode == undefined) {
        } else {
          self.pickupTypeData.countryPreference = modalData.next.CountryCode;
          self.pickupTypeData.countryName = self.getCountryName(self.pickupTypeData.countryPreference);
          let sendMoneyProgramDetail = new SendMoneyProgramDetail();
          sendMoneyProgramDetail.ProgramId = '0';
          sendMoneyProgramDetail.srcAmount = 0;
          self.sendMoneyService.setSendMoneyProgramDetailData(sendMoneyProgramDetail);
          self.cntrInit();
        }
      });
    });
  }
  openDoNotRefreshbackPoppup() {
    let self = this;
    let modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblInfo').toString();
    modalData.Message = this.translate.instant('Common_lblDoNotRefreshAndBack').toString(); //'Please select your Country of preference from the list below:';
    return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  populatePickupType() {
    this.pickupType = this.countrycollection.filter(item => item.CountryCode === this.pickupTypeData.countryPreference)[0];
    if (this.pickupType != undefined) {
      if (this.pickupType.DeliveryMethods != null) {
        this.pickupType.DeliveryMethods.sort(function(a, b) {
          return a.localeCompare(b);
        });
      }
    }
  }

  loadPickupType(type) {
    let classVal;
    switch (parseInt(type, 0)) {
      case PickupType.atmDeposit: {
        // classVal = 'disabled ' + 'atm_deposit_btn pickup_default';
        classVal = 'hide ' + 'atm_deposit_btn pickup_default';
        break;
      }
      case PickupType.bankDeposit: {
        classVal = 'bank_deposit_btn pickup_default';
        break;
      }
      case PickupType.homeDelivery: {
        classVal = 'home_delivery_btn pickup_default';
        break;
      }
      case PickupType.officePickup: {
        classVal = 'office_btn pickup_default';
        break;
      }
    }
    return classVal;
  }
  // loadPickupTypeText(type) {
  //   let classVal;
  //   switch (parseInt(type, 0)) {
  //     case PickupType.atmDeposit: {
  //       classVal = this.translate.instant('PickupType_btnAtmDeposit');
  //       break;
  //     }
  //     case PickupType.bankDeposit: {
  //       classVal = this.translate.instant('PickupType_btnBankDeposit');
  //       break;
  //     }
  //     case PickupType.homeDelivery: {
  //       classVal = this.translate.instant('PickupType_btnHomeDelivery');
  //       break;
  //     }
  //     case PickupType.officePickup: {
  //       classVal = this.translate.instant('PickupType_btnOfficePickup');
  //       break;
  //     }
  //   }
  //   return classVal;
  // }
  clickOnPickupType(pt) {
    if (pt == PickupType.atmDeposit) {
      return null;
    }
    this.pickupTypeData.pickupType = pt;
    this.pickupTypeData.countryPreference = this.pickupType.CountryCode;
    this.pickupTypeData.countryName = this.getCountryName(this.pickupTypeData.countryPreference);
    let currencies = '';

    for (var i = 0; i < this.pickupType.Currencies.length; i++) {
      if (i == 0) {
        currencies += this.pickupType.Currencies[i].CurrencyCode;
      } else {
        currencies += ',' + this.pickupType.Currencies[i].CurrencyCode;
      }
    }
    this.pickupTypeData.currencies = currencies;
    this.sendMoneyDetail.pickupTypeDetails = this.pickupTypeData;
    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
    this.sendMoneyService.setModalPopup(SendMoneySteps.PickupCenter);
  }

  ngOnDestroy() {
    if (this.subModalpopup != undefined) {
      // this.subModalpopup.unsubscribe();
    }
    if (this.subSendMoneyProgram != undefined) {
      // this.subSendMoneyProgram.unsubscribe();
    }
  }

  errorHandler(event) {
    event.currentTarget.style.display = 'none';
    //event.currentTarget.src = 'assets/images/round_emty.png';
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/pickup-type/pickup-type.component.ts